import { Schema } from "prosemirror-model";
import type { MarkType, NodeType } from "prosemirror-model";

import { marks } from "./marks.js";
import { nodes } from "./nodes.js";

export * from "./attrs.js";
export * from "./marks.js";
export * from "./nodes.js";

/** The ProseMirror schema for the full markdown dialect. */
export const schema = new Schema({ nodes, marks });

export function nodeType(name: string): NodeType {
  const type = schema.nodes[name];
  if (!type) throw new Error(`Unknown node type: ${name}`);
  return type;
}

export function markType(name: string): MarkType {
  const type = schema.marks[name];
  if (!type) throw new Error(`Unknown mark type: ${name}`);
  return type;
}
